import React, { useState, useEffect } from 'react';
import { UserDeadline } from '../constants/localStorageKeys';

const Timer = ({isActive, actionOnExpired, additionalText, isTempStopCheck}) => {
  
  let isExpiredActionProcessed = false;
  const [timeRemaining, setTimeRemaining] = useState(calculateTimeRemaining);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (isActive)
        setTimeRemaining(calculateTimeRemaining);

    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (isExpiredActionProcessed) {
      return;
    }

    if (timeRemaining < 1000) {
      if (localStorage.getItem(UserDeadline))
        actionOnExpired && actionOnExpired();

      if (isTempStopCheck != true)
        isExpiredActionProcessed = true;
    }

  }, [timeRemaining, isTempStopCheck])

  function calculateTimeRemaining() {
    const now = new Date().getTime();
    const deadline = localStorage.getItem(UserDeadline);
    const remainingTime = deadline ? Math.max(0, deadline - now) : 0;
    return remainingTime;
  }

  return (
    isActive && (
      <div className='remaining-timer'>
        <p className='timer-value'>{additionalText} {String(Math.floor(timeRemaining/1000/60)).padStart(2, '0')}:{String(Math.floor((timeRemaining - Math.floor(timeRemaining/1000/60) * 60000)/1000)).padStart(2, '0')}</p>
      </div>
    )
  );
};

export default Timer;